import React, { useState, useContext } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import '../../styles/Sidebar.css';

// Import icons (you can use react-icons or other icon libraries)
import { 
  FiHome, 
  FiUsers, 
  FiMail, 
  FiGrid, 
  FiBarChart2, 
  FiSettings, 
  FiHelpCircle, 
  FiChevronLeft, 
  FiChevronRight,
  FiLogOut
} from 'react-icons/fi';

const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { user, logout } = useContext(AuthContext);
  const location = useLocation();
  
  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };
  
  const isActive = (path) => {
    return location.pathname.startsWith(path);
  };
  
  const menuItems = [
    {
      title: 'Dashboard',
      icon: <FiHome />,
      path: '/dashboard',
    },
    {
      title: 'Clients',
      icon: <FiUsers />,
      path: '/clients',
    },
    {
      title: 'Email Templates',
      icon: <FiMail />,
      path: '/templates',
    },
    {
      title: 'Campaigns',
      icon: <FiGrid />,
      path: '/campaigns',
    },
    {
      title: 'Analytics',
      icon: <FiBarChart2 />,
      path: '/analytics',
    },
  ];
  
  const bottomMenuItems = [
    {
      title: 'Settings',
      icon: <FiSettings />,
      path: '/settings',
    },
    {
      title: 'Help & Support',
      icon: <FiHelpCircle />,
      path: '/support',
    },
  ];
  
  return (
    <aside className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        <div className="logo-container">
          {collapsed ? (
            <div className="logo-small">CRM</div>
          ) : (
            <div className="logo">CRM System</div>
          )}
        </div>
        <button className="collapse-btn" onClick={toggleSidebar}>
          {collapsed ? <FiChevronRight /> : <FiChevronLeft />}
        </button>
      </div>
      
      <div className="sidebar-content">
        <nav className="sidebar-nav">
          <ul className="nav-list">
            {menuItems.map((item) => (
              <li key={item.path} className={`nav-item ${isActive(item.path) ? 'active' : ''}`}>
                <NavLink to={item.path} className="nav-link">
                  <span className="nav-icon">{item.icon}</span>
                  {!collapsed && <span className="nav-text">{item.title}</span>}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </div>
      
      <div className="sidebar-footer">
        <nav className="sidebar-nav">
          <ul className="nav-list">
            {bottomMenuItems.map((item) => (
              <li key={item.path} className={`nav-item ${isActive(item.path) ? 'active' : ''}`}>
                <NavLink to={item.path} className="nav-link">
                  <span className="nav-icon">{item.icon}</span>
                  {!collapsed && <span className="nav-text">{item.title}</span>}
                </NavLink>
              </li>
            ))}
            <li className="nav-item">
              <button onClick={logout} className="nav-link logout-btn">
                <span className="nav-icon"><FiLogOut /></span>
                {!collapsed && <span className="nav-text">Logout</span>}
              </button>
            </li>
          </ul>
        </nav>
        
        {!collapsed && (
          <div className="user-profile">
            <div className="user-avatar">
              {user?.name?.charAt(0).toUpperCase() || 'U'}
            </div>
            <div className="user-info">
              <div className="user-name">{user?.name || 'User'}</div>
              <div className="user-email">{user?.email || 'user@example.com'}</div>
            </div>
          </div>
        )}
        {collapsed && (
          <div className="user-avatar-small">
            {user?.name?.charAt(0).toUpperCase() || 'U'}
          </div>
        )}
      </div>
    </aside>
  );
};

export default Sidebar;